import React from "react"

import { Modal, ModalBody, ModalHeader } from "reactstrap"

function VideoModal({ open, setOpen, item }) {
  const toggle = () => setOpen(!open)
  return (
    <div>
      <Modal
        isOpen={open}
        toggle={toggle}
        centered
        className="custom-size"
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          {item.title}
        </ModalHeader>
        <ModalBody className="p-3">
          <video style={{ borderRadius: "8px" }} width={"100%"} controls muted>
            <source src={item?.video_url} type="video/mp4" />
          </video>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default VideoModal
